import { fetchData } from "@client";

export async function getLatestPaymentsQuery() {
  try {
    const res = await fetchData("v2/order?limit=3");
    
    return res?.paymentHistory || [];//?.filter(p => p.detail?.length);
  } catch (e) {
    return [];
  }
}
